// Chakra imports
import { Flex, Image } from "@chakra-ui/react";

export function SidebarBrand(props) {
  const { setOpenSidebar, openSidebar, from, largeLogo } = props;
  const wordmarkSrc =
    largeLogo && (largeLogo[0]?.logoLgImg || largeLogo[0]?.logoSmImg)
      ? openSidebar === true
        ? largeLogo[0]?.logoLgImg
        : largeLogo[0]?.logoSmImg
      : `${process.env.PUBLIC_URL}/logo.png`;
  const markSrc = `${process.env.PUBLIC_URL}/apple-touch-icon.png`;

  return (
    <Flex
      align="center"
      direction="column"
      style={{
        position: "sticky",
        top: "0",
        left: "0",
        background: "#fff",
      }}
    >
      <Flex>
        <Image
          style={{
            width: openSidebar ? "190px" : "44px",
            height: "52px",
            objectFit: "contain",
          }}
          src={openSidebar ? wordmarkSrc : markSrc}
          alt="Estovex AI"
          cursor="pointer"
          onClick={() => !from && setOpenSidebar(!openSidebar)}
          userSelect="none"
          my={2}
        />
      </Flex>
    </Flex>
  );
}

export default SidebarBrand;
